import { createContext } from 'react';

/**
 * Context to provide the instanceUUID to nested components 
 * within the form renderer.
 */
export const InstanceContext = createContext<string | null>(null);